import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import InventoryService from '../../../../services/InventoryService';
import ListItemDroneInventoryGeneral from './ListItemDroneInventoryGeneral';
import { ENUMS } from '../../../../utils/constants';
import { translate, downloadFile, showMessageToastCustom } from '../../../../utils/util';
import * as lineInventoryAction from '../../../../actions/inventoryAction';
import { Title, Subtitle, ButtonIcon, BackButton, ListPagination } from '../../../../components/UI/ComponentsUI';

const InventoryGeneralListItemDrone = (props) => {
    const [itemsDrone, setItemsDrone] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (props.itemsDrone?.items?.length > 0) {
            if (itemsDrone.length > 0 && currentPage === 0) {
                setItemsDrone(props.itemsDrone.items);
            } else {
                setItemsDrone((prevState) => ([...prevState, ...props.itemsDrone.items]));
            }
        } else {
            setItemsDrone([]);
        }
        // eslint-disable-next-line
    }, [props?.itemsDrone.items]);

    useEffect(() => {
        const filter = {
            inventoryId: props.filter.inventoryId,
            lotOriginId: ENUMS.eInventoryOriginCount.Drone.value
        };

        props.getLotItems(filter, {
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (item) => {
        props.setSelectedLotItem(item);
    };

    const downloadItens = () => {
        const filter = {
            inventoryId: props.filter.inventoryId,
            lotOriginId: ENUMS.eInventoryOriginCount.Drone.value
        };

        props.getLotItemsExport(filter, (response) => {
            if (response) {
                downloadFile(response.data, response.fileName, response.type, true);
            } else {
                showMessageToastCustom(translate('warning', 'general'), translate('Nenhum item encontrado'), 3000, 'mdi mdi-alert-circle-outline red-text');
            }
        });
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check-outline" label={translate('inventory', 'inventory')} />
                    <Subtitle icon="mdi mdi-quadcopter" label={translate('general.menu.drone', 'inventory')} />
                    <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('general.menu.inventoryItems', 'inventory')} />
                    {
                        itemsDrone?.length > 0 && (<ButtonIcon icon="mdi mdi-download-outline" onClick={downloadItens} />)
                    }
                </div>
            </div>
            {
                itemsDrone && (
                    <div id="ListItemsDrone" className="container-fluid" style={{ marginTop: '40px', }}>
                        <ListPagination
                            page={props.itemsDrone?.totalPages}
                            current={{ currentPage, setCurrentPage }}
                            data={
                                itemsDrone.map((item, index) => {
                                    return (
                                        <ListItemDroneInventoryGeneral
                                            // eslint-disable-next-line react/no-array-index-key
                                            key={`oi-${index}`}
                                            route="../general/droneItem"
                                            data={item}
                                            onSelectChange={() => onSelectItemChange(item)}
                                        />
                                    );
                                })
                            }
                        />
                    </div>
                )
            }
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.inventoryReducer.filter,
        itemsDrone: state.inventoryReducer.lotItemsReading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedLotItem: (lotItem) => {
            dispatch(lineInventoryAction.selectLotItem(lotItem));
        },
        getLotItems: (filter, pagination) => {
            dispatch(InventoryService.getLotItemsReading(filter, pagination));
        },
        getLotItemsExport: (filter, callback) => {
            dispatch(InventoryService.getBytesItemsReading(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryGeneralListItemDrone)));
